import { isBaseTheme } from "./registry";
import type { ThemeDefinition, ThemeSnapshot } from "./types";

const BASE_CLASSES = ["light", "dark"];

export const themeSnapshot = (theme: ThemeDefinition): ThemeSnapshot => ({
  id: theme.id,
  base: theme.base,
  vars: Object.fromEntries(
    Object.entries(theme.tokens ?? {}).map(([token, value]) => [`--${token}`, value]),
  ),
});

/**
 * Puts a theme on <html>: the base class exactly as light/dark always did, `data-theme` for any other
 * theme (its CSS is scoped to it), and its tokens as inline variables that override :root/.dark.
 * The pre-React script in index.html does the same from the stored snapshot — keep the two in sync.
 */
export function applyThemeSnapshot(root: HTMLElement, snapshot: ThemeSnapshot) {
  root.classList.remove(...BASE_CLASSES);
  root.classList.add(snapshot.base);

  if (isBaseTheme(snapshot)) {
    root.removeAttribute("data-theme");
  } else {
    root.setAttribute("data-theme", snapshot.id);
  }

  for (const name of Array.from(root.style)) {
    if (name.startsWith("--")) root.style.removeProperty(name);
  }
  for (const [name, value] of Object.entries(snapshot.vars)) {
    root.style.setProperty(name, value);
  }
}
